<template>
  <CSidebar
    fixed
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none logo__sidebar--custom" to="/dashboard">
      <div class="c-avatar">
        <img :src="logo" class="c-avatar-img" />
      </div>
    </CSidebarBrand>

    <!-- <CRenderFunction flat :content-to-render="$options.nav" /> -->
    <CRenderFunction flat :content-to-render="navigation" />

    <!-- <CSidebarBrand class="d-md-down-none logo__sidebar--custom"> -->
      <!-- <img
        class="img-fluid mb-3"
        :src="require('@/assets/icons/ValorLatino-Blanco.svg')"
        alt="ValorLatino"
      /> -->
    <!-- </CSidebarBrand> -->

    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<style lang="scss">
.logo__sidebar--custom {
  background-color: transparent !important;
  flex: 0 0 105px !important;
  .c-avatar {
    height: 100%;
    width: auto;
    padding: 15px;
  }
}
</style>

<script>
import logo from "../assets/icons/logo_light.svg";

export default {
  data: function () {
    return {
      navigation: [],
      logo,
    };
  },
  name: "TheSidebar",

  methods: {
    async getRoutesAPI() {
      this.$store.state.token = localStorage.getItem("token");

      const payloadMenu = {
        metodo: "GETMENU",
        data: `idUser=${localStorage.getItem("profileId")}`,
      };

      try {
        const prom = await this.$store.dispatch("metodoPost", payloadMenu);
        if (prom) {
          const routes = this.$store.getters.getRespuestaREST;
          Object.values(routes._children).forEach((item) => {
            if (item.route == "") delete item.route;
          });
          this.navigation = [routes];
          this.$store.state.sidebarApps = this.navigation[0]._children;
          console.log(this.navigation[0]._children);

          for (let i = 0; i < this.navigation[0]._children.length; i++) {
            let element = this.navigation[0]._children[i].name
            if(element == "Cotizador APE Web") {
              localStorage.setItem('idRol', this.navigation[0]._children[i]._idRol)
              // console.log(this.navigation[0]._children[i]._idRol);
            }
          }

          if (this.$store.state.sidebarApps.length == 0) {
            this.logOut("No tienes aplicaciónes asignadas");
          }

          this.$store.state.Loading = false;
          return;
        }
      } catch (error) {
        this.logOut("Tu token ha expirado");
      }
    },

    async logOut(message) {
      this.$store.state.Loading = false;
      const res = await this.$swal.fire({
        title: message,
        icon: "warning",
        allowOutsideClick: false,
      });

      if (res.isConfirmed) {
        localStorage.removeItem("token");
        this.$router.push("/pages/login");
      }
    },
  },
  computed: {
    show() {
      return this.$store.state.sidebarShow;
    },
    minimize() {
      return this.$store.state.sidebarMinimize;
    },
  },
  async mounted() {
    this.getRoutesAPI();
  },
};
</script>
